<template>
  <div class="tw:bg-gray-100 tw:rounded-xl tw:p-4 tw:flex tw:gap-x-4 tw:items-center">
    <div
      class="tw:bg-decorative-lightblue tw:rounded-full tw:flex tw:items-center tw:justify-center tw:flex-shrink-0 tw:w-12 tw:h-12"
    >
      <img :src="icon" role="presentation" alt="" class="tw:w-6 tw:h-6 tw:object-contain" />
    </div>

    <div>
      <div class="tw:flex tw:items-center">
        <h6 class="tw:font-bold">{{ $t(title) }}</h6>
        <UiTooltip theme="customdarkwithpadding" tooltip-position="top" :label="$t(hint)">
          <InformationOutline class="tw:fill-none tw:stroke-gray-500 tw:h-[18px] tw:w-[18px] tw:ml-1" />
        </UiTooltip>
      </div>
      <p class="tw:text-[32px]">{{ new Intl.NumberFormat(language).format(value) }}</p>
    </div>
  </div>
</template>
<script setup>
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'

import { useSessionValues } from '@/composables/useSessionValues'

const { language } = useSessionValues()
defineProps({
  icon: String,
  title: String,
  value: Number,
  hint: String,
})
</script>
